import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        La ŝuoj triviĝis, laciĝis ĉeval’ en vesper’ <br/>
        Sed kien mi venu? Respondu al mi sen erar’. <br/>
        - Laŭ Ruĝa river’, mia ĝojo, laŭ Ruĝa river’, <br/>
        Ĝis Blua montar’, mia ĝojo, ĝis Blua montar’.
      </p>

      <p class="poem-block mb-3">
        Sed kiel mi venu? Pro laco jam stumblas ĉeval’, <br/>
        Bonvolu klarigi la vojon al tiu teren’. <br/>
        - Vi rajdu al lum’, kiu flamas post hela kristal’, <br/>
        Vi rajdu al lum’, mia ĝojo, kaj trovos sen pen’.
      </p>

      <p class="poem-block mb-3">
        Sed kie la lum’ tiu klara en nokta obskur’? <br/>
        Centjaron mi vagas, sed nokton ne ŝiras radi’. <br/>
        - Ekdormis, verŝajne, l’ gardist’, kaj lanterno sur tur’ <br/>
        Ne lumas, sed mi, mia ĝojo, ne scias pri ĝi.
      </p>

      <p class="poem-block mb-3">
        Kaj jen li veturas soleca sub nigra ĉiel’, <br/>
        Sed kien, ja voj’ ne videblas al ajna ekstrem’? <br/>
        - Ho, kion vi perdis, - mi krias, - kaj kia la cel’? <br/>
        Kaj li, mia ĝojo, respondas: «Ne scias mi mem».
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Nokta interparolo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['rWNyvJDzK6A'],
    itemTranslator: `
      Teksto kaj muziko: Bulat Okuĝava, <br/>
      ${translator.esp}
    `
  }
}

export default item;